module.exports = __webpack_public_path__ + "static/media/work.34fbe4e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/work.jpg
// module id = 141
// module chunks = 0